import { createContext, useContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
const Ctx = createContext(null);

export function ImpersonateProvider({ children }) {
  const navigate = useNavigate();
  const [impLab, setImpLab] = useState(() => {
    try { return JSON.parse(localStorage.getItem('imp_lab') || 'null'); } catch { return null; }
  });

  const enter = useCallback(async (labId) => {
    const origToken = localStorage.getItem('token');
    const r = await axios.post(
      `${API}/super/labs/${labId}/impersonate-token`,
      {},
      { headers: { Authorization: `Bearer ${origToken}` } }
    );
    localStorage.setItem('imp_orig_token', origToken);
    localStorage.setItem('token', r.data.token);
    localStorage.setItem('imp_lab', JSON.stringify(r.data.lab));
    // Impersonate kirganida LabContext'ni ham shu klubga tirab qo'yamiz —
    // aks holda eski `selected_lab_id` X-Lab-Id'ga tushib, backend 403 beradi.
    if (r.data.lab?.id) {
      try { localStorage.setItem('selected_lab_id', String(r.data.lab.id)); } catch {}
    }
    setImpLab(r.data.lab);
    navigate('/');
  }, [navigate]);

  const exit = useCallback(() => {
    const orig = localStorage.getItem('imp_orig_token');
    if (orig) localStorage.setItem('token', orig);
    localStorage.removeItem('imp_orig_token');
    localStorage.removeItem('imp_lab');
    // Impersonate chiqishida LabContext tanlovini ham tozalaymiz — asl
    // super-admin uchun o'sha klub ID endi mos emas.
    try { localStorage.removeItem('selected_lab_id'); } catch {}
    setImpLab(null);
    navigate('/super/labs');
  }, [navigate]);

  return <Ctx.Provider value={{ impLab, enter, exit }}>{children}</Ctx.Provider>;
}

export const useImpersonate = () => useContext(Ctx);
